import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import { Row, Col } from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import Footer from "./footer";
import Header from "./header";
import {
  listvehicle,
  listvehiclewise,
  vehroutelist,
  vehtriplist,
  vehicledriverattendance,
  transportpushcreate,
} from "../service/dashboard";
import moment from "moment";
import { toast } from "react-toastify";

const AddTransportAttendance = () => {
  const navigate = useNavigate();

  const [vlist, setVList] = useState([]);   // vehicle options (with route/trip ids)
  const [rlist, setRList] = useState([]);   // all routes (master)
  const [tlist, setTList] = useState([]);   // all trips (master)
  const [vehRoutes, setVehRoutes] = useState([]); // routes for selected vehicle
  const [vehTrips, setVehTrips] = useState([]);   // trips for selected vehicle
  const [dlist, setDList] = useState([]);   // students to mark
  const [spush, setSPush] = useState(true); // Send Push Notification

  const [form, setForm] = useState({
    vehicle: "",
    route: "",
    trip: "",
    time: "",
    date: moment(new Date()).format("YYYY-MM-DD"),
  });

  useEffect(() => {
    const temp = new FormData();
    temp.append("academy_id", localStorage.getItem("academy"));
    temp.append("status", 1);
    listvehicle(temp).then((res) => {
      if (res && res.status === true && res.data.details.length > 0) {
        const arr = res.data.details.map((item) => ({
          value: item.id,
          label: item.vehicle_no + " - " + item.worker_name,
          routeIds: item.vehicle_route,
          tripIds: item.vehicle_trip,
        }));
        setVList(arr);
      }
    });

    const temp1 = new FormData();
    temp1.append("academy_id", localStorage.getItem("academy"));
    vehroutelist(temp1).then((res) => {
      if (res && res.status === true) {
        setRList(res.data);
      }
    });

    vehtriplist(temp1).then((res) => {
      if (res && res.status === true) {
        setTList(res.data);
      }
    });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    setDList([]);

    // Scope route/trip dropdowns to the chosen vehicle's configured ids
    if (name === "vehicle") {
      const veh = vlist.find((v) => String(v.value) === String(value));
      const routeIds = String(veh?.routeIds || "").split(",").map((v) => v.trim()).filter((v) => v !== "");
      const tripIds = String(veh?.tripIds || "").split(",").map((v) => v.trim()).filter((v) => v !== "");
      setVehRoutes(rlist.filter((r) => routeIds.includes(String(r.id))));
      setVehTrips(tlist.filter((t) => tripIds.includes(String(t.id))));
      setForm((prev) => ({ ...prev, vehicle: value, route: "", trip: "" }));
    }
  };

  // Load students for the selected vehicle
  const handlePreview = () => {
    if (form.vehicle === "") { toast.error("Please Select Vehicle"); return; }
    if (form.route === "") { toast.error("Please Select Route"); return; }
    if (form.trip === "") { toast.error("Please Select Trip"); return; }
    if (form.time === "") { toast.error("Please Select Time"); return; }
    if (form.date === "") { toast.error("Please Select Date"); return; }

    const temp = new FormData();
    temp.append("academy_id", localStorage.getItem("academy"));
    temp.append("role", 4);
    temp.append("vehicle", form.vehicle);
    temp.append("trip", form.trip);
    listvehiclewise(temp).then((res) => {
      if (res && res.status === true && res.data.details.length > 0) {
        // Students are assigned to trips (comma-separated trip_id, a student can
        // belong to more than one). Narrow the list to the selected trip when the
        // rows carry trip info; otherwise leave the list unchanged.
        const hasTrip = res.data.details.some(
          (s) => s.trip_id !== undefined && s.trip_id !== null && s.trip_id !== ""
        );
        const details = hasTrip
          ? res.data.details.filter((s) =>
              String(s.trip_id)
                .split(",")
                .map((x) => x.trim())
                .includes(String(form.trip))
            )
          : res.data.details;
        if (details.length === 0) {
          toast.error("No students found for this trip");
          setDList([]);
          return;
        }
        const updated = details.map((student) => ({
          ...student,
          remark: "",
          trip: "",
          status: 1,
        }));
        setDList(updated);
      } else {
        toast.error("No students found for this vehicle");
        setDList([]);
      }
    });
  };

  const handleToggle = (personId) => {
    setDList((prev) =>
      prev.map((s) =>
        s.person_id === personId ? { ...s, status: s.status == 1 ? 0 : 1 } : s
      )
    );
  };

  const handleAllChange = (status) => {
    setDList((prev) => prev.map((s) => ({ ...s, status })));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const temp = new FormData();
    temp.append("attendance_date", form.date);
    temp.append("attendance_time", form.time);
    temp.append("count", dlist.length);
    temp.append("academy_id", localStorage.getItem("academy"));
    temp.append("route_id", form.route);
    for (let i = 0; i < dlist.length; i++) {
      temp.append("id_" + [i + 1], dlist[i].id);
      temp.append("trip_id_" + [i + 1], form.trip);
      temp.append("role_id_" + [i + 1], 4);
      temp.append("stu_id_" + [i + 1], dlist[i].person_id);
      temp.append("attend_status_" + [i + 1], dlist[i].status);
      if (dlist[i].remark) {
        temp.append("remarks_" + [i + 1], dlist[i].remark);
      }
    }

    vehicledriverattendance(temp).then((res) => {
      if (res && res.status === true) {
        toast.success(res.message);

        // Send push notification (same as web transport flow), gated by checkbox
        if (spush && dlist.length > 0) {
          const firstItem = dlist[0];
          const pushData = new FormData();
          pushData.append("date", form.date);
          pushData.append("time", form.time);
          pushData.append("role_id", 4);
          pushData.append("vehicle_no", firstItem.vehicle_no || "");
          pushData.append("route_name", vehRoutes.find((r) => String(r.id) === String(form.route))?.vehroute_name || "");
          pushData.append("academy_id", localStorage.getItem("academy"));
          dlist.forEach((item) => {
            pushData.append("student_ids[]", item.person_id);
            pushData.append("student_names[]", item.person_name || "");
            pushData.append("student_statuses[]", item.status);
          });
          transportpushcreate(pushData).then((pres) => {
            if (pres && pres.status === true) {
              toast.success("Push notifications sent");
            }
            navigate("/transportattendance");
          });
        } else {
          navigate("/transportattendance");
        }
      } else {
        toast.error(res.message);
      }
    });
  };

  const presentCount = dlist.filter((s) => s.status == 1).length;
  const absentCount = dlist.length - presentCount;

  return (
    <div id="mainpage">
      <div className="maincontent">
        <Header />

        <div className="moreheading">
          <Row className="row-sm align-items-center">
            <Col xs={12} sm={6} className="text-left mb-2 mb-sm-0">
              <h4 className="morehead-text mb-0">Transport Attendance</h4>
            </Col>
            <Col xs={12} sm={6}>
              <div className="d-flex flex-wrap justify-content-start justify-content-sm-end gap-2">
                <Link to={"/transportattendance"} className="btn-outline-success red-btn btn-sm">
                  <i className="fa-solid fa-hand-point-left"></i> Go Back
                </Link>
              </div>
            </Col>
          </Row>
        </div>

        <div className="card-body">
          <form>
            <div className="mb-3">
              <label className="form-label attachment">Vehicle <span>*</span></label>
              <select
                className="form-select"
                name="vehicle"
                value={form.vehicle}
                onChange={handleChange}
                required
              >
                <option value="">Select Vehicle</option>
                {vlist.map((item, i) => (
                  <option value={item.value} key={i}>{item.label}</option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label attachment">Route <span>*</span></label>
              <select
                className="form-select"
                name="route"
                value={form.route}
                onChange={handleChange}
                required
              >
                <option value="">Select Route</option>
                {vehRoutes.map((r) => (
                  <option value={r.id} key={r.id}>{r.vehroute_name}</option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label attachment">Trip <span>*</span></label>
              <select
                className="form-select"
                name="trip"
                value={form.trip}
                onChange={handleChange}
                required
              >
                <option value="">Select Trip</option>
                {vehTrips.map((t) => (
                  <option value={t.id} key={t.id}>{t.vehtrip_name}</option>
                ))}
              </select>
            </div>

            <div className="mb-3">
              <label className="form-label attachment">Date <span>*</span></label>
              <input
                type="date"
                name="date"
                className="form-control"
                value={form.date}
                onChange={handleChange}
                required
              />
            </div>

            <div className="mb-3">
              <label className="form-label attachment">Time <span>*</span></label>
              <select
                className="form-select"
                name="time"
                value={form.time}
                onChange={handleChange}
              >
                <option value="">Select Time</option>
                <option value="Morning">Morning</option>
                <option value="Evening">Evening</option>
              </select>
            </div>

            <div className="text-center">
              <button type="button" className="btn btn-success px-5" onClick={handlePreview}>
                Preview
              </button>
            </div>
          </form>
        </div>

        {dlist.length != 0 &&
          <div className="container my-4">
            <div className="d-flex justify-content-center gap-4 mb-4">
              <div className="text-center bg-light p-3 rounded shadow-sm">
                <div className="text-success fw-bold fs-4">{presentCount}</div>
                <div>Present</div>
              </div>
              <div className="text-center bg-light p-3 rounded shadow-sm">
                <div className="text-danger fw-bold fs-4">{absentCount}</div>
                <div>Absent</div>
              </div>
            </div>

            <div className="mb-3 text-center">
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="all"
                  id="allPresent"
                  defaultChecked
                  onClick={() => handleAllChange(1)}
                />
                <label className="form-check-label" htmlFor="allPresent">All Present</label>
              </div>
              <div className="form-check form-check-inline">
                <input
                  className="form-check-input"
                  type="radio"
                  name="all"
                  id="allAbsent"
                  onClick={() => handleAllChange(0)}
                />
                <label className="form-check-label" htmlFor="allAbsent">All Absent</label>
              </div>
            </div>

            <table className="table table-bordered align-middle text-center">
              <thead className="table-light table-head-color">
                <tr>
                  <th>Name</th>
                  <th>Status</th>
                </tr>
              </thead>
              <tbody>
                {dlist.map((student) => (
                  <tr key={student.person_id}>
                    <td>
                      {student.person_name}
                      {student.class_name ? " - " + student.class_name : ""}
                      {student.section_name ? " - " + student.section_name : ""}
                    </td>
                    <td>
                      <div className="form-check form-switch d-flex align-items-center justify-content-center">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={student.status == 1}
                          onChange={() => handleToggle(student.person_id)}
                        />
                        <span className={`ms-2 fw-bold ${student.status == 1 ? "text-success" : "text-danger"}`}>
                          {student.status == 1 ? "Present" : "Absent"}
                        </span>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            <div className="form-check d-flex justify-content-center align-items-center gap-2 mt-3">
              <input
                className="form-check-input"
                type="checkbox"
                id="sendPush"
                checked={spush}
                onChange={(e) => setSPush(e.target.checked)}
              />
              <label className="form-check-label" htmlFor="sendPush">
                Send Push Notification
              </label>
            </div>

            <div className="text-center mt-4">
              <button className="btn btn-primary add-homework-submit px-5" onClick={handleSubmit}>
                Confirm & Submit Attendance
              </button>
            </div>
          </div>
        }
      </div>
      <Footer />
    </div>
  );
};

export default AddTransportAttendance;
